module.exports = __webpack_public_path__ + "img/round-arrow-right-lightblue.710e4956.svg";